var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51517 1.10983C9.66161 1.25628 9.66161 1.49372 9.51517 1.64017L4.26516 6.89016C4.19484 6.96049 4.09946 7 4 7C3.90054 7 3.80516 6.96049 3.73484 6.89016L1.10983 4.26516C0.963388 4.11872 0.963388 3.88128 1.10983 3.73484C1.25628 3.58839 1.49372 3.58839 1.64017 3.73484L4 6.09467L8.98483 1.10983C9.13128 0.963388 9.36872 0.963388 9.51517 1.10983Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f18b09f927d17985d8950c3186c6b4b9.svg";
export { ForwardRef as ReactComponent };